import { importExportHu } from './hu/imp_lang';
import { importExportEn } from './en/imp_lang';

export type ImportExportLang = typeof importExportHu;

export const getImportExportLang = (language: string): ImportExportLang => {
  return language === 'en' || language === 'English' ? importExportEn : importExportHu;
};
